/**
 * Tag color utility for consistent hash-based tag coloring
 */

interface TagColor {
  bg: string;
  text: string;
}

// Predefined palette of harmonious colors
const TAG_COLORS: TagColor[] = [
  { bg: '#E8F5E9', text: '#2E7D32' }, // Green
  { bg: '#E3F2FD', text: '#1565C0' }, // Blue
  { bg: '#FFF3E0', text: '#E65100' }, // Orange
  { bg: '#F3E5F5', text: '#7B1FA2' }, // Purple
  { bg: '#FFEBEE', text: '#C62828' }, // Red
  { bg: '#E0F7FA', text: '#00838F' }, // Teal
  { bg: '#FFF8E1', text: '#F9A825' }, // Amber
  { bg: '#FCE4EC', text: '#AD1457' }, // Pink
  { bg: '#EDE7F6', text: '#5E35B1' }, // Deep Purple
  { bg: '#E1F5FE', text: '#0277BD' }, // Light Blue
];

/**
 * Generate a consistent color for a tag name using a hash function
 * Same tag name will always return the same color
 */
export function getTagColor(tagName: string): TagColor {
  let hash = 0;
  for (let i = 0; i < tagName.length; i++) {
    const char = tagName.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32-bit integer
  }
  const index = Math.abs(hash) % TAG_COLORS.length;
  return TAG_COLORS[index];
}

/**
 * Get all available tag colors
 */
export function getAllTagColors(): TagColor[] {
  return [...TAG_COLORS];
}
